class ReactKeyUtils {
  static generateRandomKey(): string {
    return (`${  new Date().getTime()  }-${  Math.random()}`);
  }
}

export default ReactKeyUtils;
